import { render, staticRenderFns } from "./Mercadoria.vue?vue&type=template&id=17f77dad"
import script from "./Mercadoria.vue?vue&type=script&lang=js"
export * from "./Mercadoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports